import * as React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

class TopLevelModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    const topModalRoot = document.getElementById('rc-TopLevelModal');

    // This render function should be skipped if the Top Level Modal is already in the DOM
    if (!topModalRoot) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
      this.node = document.createElement('div');
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
      this.node.setAttribute('id', 'rc-TopLevelModal');
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
      document.body.appendChild(this.node);
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
      this.node = topModalRoot;
    }
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
    document.body.removeChild(this.node);
  }

  render() {
    if (this.state.isMounted) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'node' does not exist on type 'TopLevelMo... Remove this comment to see the full error message
      return ReactDOM.createPortal(this.props.children, this.node);
    }
    return null;
  }
}

export default TopLevelModal;
